/**
 * FlashcardFocusButton
 *
 * A button component to trigger flashcard focus mode in message content
 *
 * Primary responsibilities:
 * - Display a button to enter focus mode for flashcards in a message
 * - Track and manage the focus mode dialog state
 * - Extract flashcard data from message content
 */

import React, { useState } from 'react'
import { Button } from '@/components/ui/button'
import { IconCards, IconFocus, IconSearch } from '@tabler/icons-react'
import { FlashcardFocusMode, FlashcardItem } from './flashcard-focus-mode'

interface FlashcardFocusButtonProps {
  flashcards: FlashcardItem[]
}

export const FlashcardFocusButton: React.FC<FlashcardFocusButtonProps> = ({ flashcards }) => {
  const [isFocusModeOpen, setIsFocusModeOpen] = useState(false)

  if (!flashcards.length) return null

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="mb-4 mt-2 flex items-center gap-2"
        onClick={() => setIsFocusModeOpen(true)}
      >
        <IconSearch size={14} />
        <span>Open Flashcards in Focus Mode ({flashcards.length})</span>
      </Button>

      <FlashcardFocusMode
        flashcards={flashcards}
        isOpen={isFocusModeOpen}
        onOpenChange={setIsFocusModeOpen}
      />
    </>
  )
}
